module.exports = {"StatusCode":200,"Payload":"[{\"updatedData\":{\"pages\":[],\"templates\":[],\"drafts\":[],\"recycled\":[],\"linkedBy\":[],\"siteMap\":[]},\"newSite\":{\"meta\":\"\",\"favicon\":\"\"}}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/publishBoilerplate.json
// module id = Hk39
// module chunks = 0